const KEY = "nameit_test_account";

// Dev only: a tab opened with ?testAccount=1 (scripts/desktop-test-game.cjs does
// this) tags every account it creates, so the admin dashboard leaves them out.
// Production builds never read the flag.
export function markTestSession() {
  if (!import.meta.env.DEV || !new URLSearchParams(window.location.search).has("testAccount")) return;
  try {
    sessionStorage.setItem(KEY, "1");
  } catch {
    // storage unavailable: the account is just not tagged
  }
}

export function isTestSession() {
  if (!import.meta.env.DEV) return false;
  try {
    return sessionStorage.getItem(KEY) === "1";
  } catch {
    return false;
  }
}
